angular.module( 'acme.view.application.orders.requests.modals.removeOrderRequest', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.orders.requests.modals.removeOrderRequest.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var ordersRequestsModalsRemoveOrderRequest = {
        name: 'application.orders.requests.modals.removeOrderRequest',
        url: '/orders/requests/modals/removeOrderRequest',
        views: {
          "main": {
            controller: 'OrdersRequestsModalsRemoveOrderRequestController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/orders/requests/modals/removeOrderRequest/removeOrderRequest.tpl.html'
          }
        },
        data: {
          pageTitle: '    ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(ordersRequestsModalsRemoveOrderRequest);
});
